import moment from 'moment';

const DateHelper = {};

DateHelper.formatDateToDDMMYYYY = (date) => {
    return moment(date).format('DD-MM-YYYY');
}

export default DateHelper;